<template>
  <!-- eslint-disable -->
  <div class="container">
    <a-table class="table" :columns="columns" :loading="loading" :dataSource="list" rowKey="id" :pagination="false">
      <template v-slot:reason="text">
        <v-clamp autoresize :max-lines="2" class="clamp-container">
          <template>
            {{ text }}
          </template>
          <template v-slot:after="{ toggle, expanded, clamped }">
            <a-button v-if="expanded || clamped" type="link" class="link" @click="toggle">{{ expanded ? '收起' : '展开' }}</a-button>
          </template>
        </v-clamp>
      </template>

      <template v-slot:relatedUserName="text, record">
        {{ convertRelatedUserName(record) }}
      </template>


      <template v-slot:feedbackInfo="text, record">
        <div>
          <router-link
            :to="{ path: '/humint/demand/feedbackInfo', query: { id: item.id } }"
            class="feedback-button"
            v-for="item in record.feedbackInfo"
            :key="item.receiveName"
          >
            {{ item.receiveName }}-{{ getFamiliarityName(item.familiarity) }}
          </router-link>
        </div>
      </template>
    </a-table>
    <div class="footer" v-if="pageInfo.total > pageInfo.pageSize">
      <a-pagination :current="pageInfo.page" :total="pageInfo.total" :pageSize="pageInfo.pageSize" @change="onChange" :show-total="total => `共${total}项`" />
    </div>
  </div>
</template>
<script>
import VClamp from 'vue-clamp';
import { queryMyTask } from '@/api/humint';
import moment from 'moment';
import { familiarityOptions } from './components/constants';

export default {
  components: {
    VClamp
  },
  data() {
    const columns = [
      {
        title: '找人需求描述',
        dataIndex: 'reason',
        key: 'reason',
        scopedSlots: {
          customRender: 'reason'
        }
      },
      {
        title: '发布时间',
        dataIndex: 'createAt',
        key: 'createAt'
      },
      {
        title: '让TA找',
        key: 'relatedUserName',
        dataIndex: 'relatedUserName',
        scopedSlots: {
          customRender: 'relatedUserName'
        }
      },
      {
        title: '反馈情况',
        key: 'feedbackInfo',
        dataIndex: 'feedbackInfo',
        scopedSlots: {
          customRender: 'feedbackInfo'
        }
      }
    ];

    return {
      columns,
      list: [],
      loading: false,
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  mounted() {
    this.queryMyTask();
  },
  methods: {
    async queryMyTask() {
      this.loading = true;
      let res = await queryMyTask({
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize
      }).finally(() => {
        this.loading = false;
      });
      if (res.code === 200) {
        this.list = res.data.list.map(i => {
          i.createAt = moment(i.createAt).format('YYYY/MM/DD');
          return i;
        });
        this.pageInfo.total = res.data.total;
      }
    },
    getFamiliarityName(value) {
      let item = familiarityOptions.find(i => i.value === value);
      return item ? item.label : '';
    },
    convertRelatedUserName(record) {
      switch (record.relatedType) {
      case 0:
        return '全员';
        break;
      case 1:
        return record.relatedUserName.map(i => i + '所在部门').join(', ');
        break;
      case 2:
        return record.relatedUserName.join(', ');
        break;
      }
    },
    onChange(page, pageSize) {
      this.pageInfo.page = page;
      this.pageInfo.pageSize = pageSize;
      this.queryMyTask();
    }
  }
};
</script>
<style lang="less" scoped>
.footer {
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
}
.clamp-container {
  @media only screen and (max-width: 800px) {
    max-width: 70px;
  }
  @media only screen and (min-width: 800px) {
    max-width: 300px;
  }
  .link {
    padding: 0 5px;
  }
}
.feedback-button {
  display: block;
  padding: 0 5px;
  margin-bottom: 15px;
  min-width: 51px;
  &:last-child {
    margin-bottom: 0;
  }
  @media only screen and (min-width: 800px) {
    word-break: keep-all;
    white-space: nowrap;
  }
}
/deep/ .ant-table-tbody > tr > td {
  @media only screen and (max-width: 800px) {
    padding: 10px 5px;
  }
}
</style>
